import React from "react";
import GoogleCalendarCard from "./GoogleCalendarCard";

interface IntegrationsTabProps {
  assistantId: string;
}

const IntegrationsTab: React.FC<IntegrationsTabProps> = ({ assistantId }) => {
  return (
    <div className="w-full flex flex-col gap-4">
      <GoogleCalendarCard assistantId={assistantId} />
    </div>
  );
};

export default IntegrationsTab;
